// extracted by mini-css-extract-plugin
module.exports = {"NewFeatureCheckout":"hg_a bhs_bi","NewFeatureCheckout__explainLink":"hg_b bhs_uq bhs_rc"};